'use client'

import { cn } from '@/lib/utils'

export function TrustedByBar({ className }: { className?: string }) {
  return (
    <div className={cn('space-y-2 text-center', className)}>
      <p className='text-xs font-medium uppercase tracking-widest text-white/40'>
        Supervity
      </p>
      <p className='text-sm font-medium text-white/70'>
        Where Intelligence Meets Human.
      </p>
    </div>
  )
}
